import CustomElement from '../core/custom.js';
import App from '../stores/app.js'
import { easeInOutQuad } from '../utilities/easings.js';

export default window.customElements.define('scroll-to', class extends CustomElement {
    constructor() {
        super();

		this.events = {
            'click a': 'onClick'
        };
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

	onClick(event) {
		event.preventDefault()

		const target = document.getElementById(event.target.getAttribute('href').substr(1))

        App.lenis.scrollTo(target, { 
			duration: 0.8, 
			easing: easeInOutQuad
		})

		// target && target.scrollIntoView({
		// 	behavior: 'smooth',
		// 	block: 'start'
		//   });
	}
});
